import React, { useEffect, useState } from 'react';
import Columns from '@/components/Columns';
import Column from '@/components/Column';
import Button from '@/components/Button';
import Text from '@/components/Text';
import './styles.css';

type ChangePriceAlertProps = {
  setShowChangePriceAlert(value: boolean): void;
  currentPrice: number;
};

const ChangePriceAlert: React.FC<ChangePriceAlertProps> = ({
  setShowChangePriceAlert,
  currentPrice,
}) => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    setTimeout(() => setShow(true), 100);
  }, []);
  return (
    <div
      className={`alert-change-container flex items-center justify-center ${
        show ? 'opacity-100' : 'opacity-0'
      }`}
    >
      <Columns
        as='aside'
        className='mx-6 flex flex-col items-center justify-center rounded-lg bg-white p-5 lg:m-0'
        useNegativeMargin={false}
      >
        <Text as='h1' kind='blue' size='2xl' className='font-bold'>
          Mudança de preço
        </Text>
        <Column className='itens-center flex flex-col justify-between'>
          <Text as='h3' kind='gray' size='base' className='p-2 text-center'>
            O DDD informado é diferente da região que você selecionou e isso
            pode alterar os valores do plano.
          </Text>
          <Text as='h3' kind='gray' size='base' className='p-2 text-center'>
            A oferta escolhida custa R$ {String(currentPrice).replace('.', ',')}
            /mês em sua região.
          </Text>
          <Text as='h3' kind='gray' size='base' className='p-2 text-center'>
            Por isso o valor foi atualizado.
          </Text>
          <Column className='px-5 pt-2'>
            <Button
              kind='primary'
              large
              onClick={() => setShowChangePriceAlert(false)}
            >
              Entendi
            </Button>
          </Column>
        </Column>
      </Columns>
    </div>
  );
};

export default ChangePriceAlert;
